module.exports = __webpack_public_path__ + "static/img/0002合规测评.38ae386.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/picImgs/0002合规测评.jpg
// module id = 9D/z
// module chunks = 0